var Backbone = require('backbone'),
    _ = require('underscore'),
    BoxModel = require('../../../../models/coordinate/redaction/floating/codeBox'),
    ConnectionModel = require('../../../../models/coordinate/redaction/floating/connection'),
    ShapeUtils = require('../../../../models/shapeUtils'); // TODO: call this calc's or something ...

module.exports = Backbone.Model.extend({

    idAttribute: 'uniqueCodeString', // useful if use in a collection

    defaults: {

        uniqueCodeString: null, // the 'id' of the collection
        shapeViewIds: [], // cids of the views are are connected to it
        codeViewId: null, // cid of the reason code view

        // codesWerePositioned: true if ---
            // 1) view was dragged (dragStart), or
            // 2) more than one shape view had been connected (it doesn't go back), or
            // 3) read in on load of canvas from the controller
            // ( originally: saved note when certain conditions are met ( set on init of this model where options.renderBoxFromShapeModelPts = true )
            // once true -- never goes back
        codesWerePositioned: false,

        pgDPI: 200, // DPI of the page used in font-size calcs; set on init -- TODO: use a better default???


        /*
        * Set on init with pgDPI taken into account -- what is used to print the text.
        * Converted from points to pixels (different than the box model).
        * What is used in rendering the letters on the screen -- not persisting them.
        *  .... so this default value essentially never used ...
        * */

        adjustedFontSize: BoxModel.prototype.defaults.fontSize,
        adjustedLineHeight: BoxModel.prototype.defaults.lineHeight,

        // ui attributes & state -- triggering events

        // setting here solves problem of activating code view multiple times if they're attached to > 1 shapeView;
        // the shape views will each listen to the events and this set accordingly, but it will only change change (and fire) once
        parentNoteIsActive: false,

        /*
        * Stroke-width and padding now stored as pt -- convert them to pixels for rendering ...
        * */
        adjustedStrokeWidth: BoxModel.prototype.defaults.strokeWidth,
        adjustedPadding: BoxModel.prototype.defaults.padding,


        // Adjusted property from the line
        adjustedConnectionWidth: ConnectionModel.prototype.defaults.width,
        adjustedConnectionDashArray: ConnectionModel.prototype.defaults.dashArray

    },

    initialize: function(attrs, options) {

        if (options.renderBoxFromShapeModelPts) {

            // Note: the points here have already been 'adjusted'
            this.boxModel = options.boxModel;
            this.connectionModel = options.connectionModel;

            this.set({
                codesWerePositioned: true
            });

        } else {

            this.boxModel = new BoxModel();
            this.connectionModel = new ConnectionModel();

        }

        var pgDpi = this.get('pgDPI');

        // TODO: will need different model if/when we let the user change these values (and others) -- maybe an intermediary render attributes object
        // perhaps an alternative is converting automatically to pixel on way in and way out like we do for the shape
        // ... should prob think about this now ...
        // ... now static and defaults taken directly from the box
        // eg on save the values are taken from the box model, which would be the unconverted values here ...
        // all values applied should come from this: eg lineHeight comes from the codebox, not here ... this should be changed especially when we let users change values

        // Font-Size: Stored in Pts
        var adjustedFontSize = +( (ShapeUtils.ptToPx( this.boxModel.get('fontSize') ) * (pgDpi / 96)).toFixed(3) );

        // Stroke-Width: 1/10 mm
        var adjustedStrokeWidth = +( (this.boxModel.get('strokeWidth') * ShapeUtils.INCHES_TENTHS_MM_TRANS * pgDpi).toFixed(3) )  ;

        // Padding: 1/10 mm
        var adjustedPadding = +( (this.boxModel.get('padding') * ShapeUtils.INCHES_TENTHS_MM_TRANS * pgDpi).toFixed(3) );

        // Connection width:  1/10 mm
        var baseConnectionWidth = this.connectionModel.get('width');
        var adjustedConnectionWidth = +( ( baseConnectionWidth * ShapeUtils.INCHES_TENTHS_MM_TRANS * pgDpi).toFixed(3) );

        var baseDashArray = this.connectionModel.get('dashArray');

        /*
        * Connection Dash-Array: 1/10 mm values.
        * Adjust by multiplying by connection width at onset, rather than whenever a scale is applied using current hack.
        * If the base is null or an empty array; will be set to null (also serving as a flag).
        * */

        var adjustedConnectionDashArray = ( baseDashArray && baseDashArray.length > 0 )
            ? _.map( baseDashArray, function( dashValue ) {
                return +( dashValue  * baseConnectionWidth * ShapeUtils.INCHES_TENTHS_MM_TRANS * pgDpi).toFixed(3);
            })
         : null;

        this.set({
            adjustedFontSize: adjustedFontSize,
            adjustedLineHeight: adjustedFontSize * this.boxModel.get('lineHeight'), // calculate off the pixels
            adjustedStrokeWidth: adjustedStrokeWidth,
            adjustedPadding: adjustedPadding,

            adjustedConnectionWidth: adjustedConnectionWidth,
            adjustedConnectionDashArray: adjustedConnectionDashArray
        });

    },

    addShapeViewId: function(cid) {
        var newCids = _.uniq( this.get('shapeViewIds').concat(cid) );
        this.set('shapeViewIds', newCids);
        (newCids.length > 1) && this.set('codesWerePositioned', true);
    },
    removeShapeViewId: function(cid) {
        this.set('shapeViewIds', _.without( this.get('shapeViewIds'), cid  ));
    },

    getBoxCoordinates: function() {
        return this.boxModel.get('points');
    },

    /*
    * Note: this is the 'border' path.
    * */
    getBorderElAttrs: function() {

        var boxAttrs = this.boxModel.toJSON();

        return {
            'stroke-width': this.getStrokeWidth(), // (now adjusted from pts to px)
            stroke: boxAttrs.stroke,
            'stroke-opacity': boxAttrs.strokeOpacity
        };

    },

    /*
    * The 'inner box' -- fill, not-stroke
    * */

    getInnerElAttributes: function() {

        var boxAttrs = this.boxModel.toJSON();

        return {
            stroke: 'none',
            fill: boxAttrs.fill,
            'fill-opacity': boxAttrs.fillOpacity
        };
    },

    /*
    * The Raphael attributes to apply the text path on render.
    * Include all but 'lineHeight', which isn't an available Raphael attribute,
    * or valid SVG attribute.
    * It's applied separately via a data attribute to calc the dy of generated tspans
    * ( font-size * lineHeight ).
    * */
    getTextElAttrs: function() {

        var boxAttrs = this.boxModel.toJSON();

        return {
            'font-family': boxAttrs.font,
            'font-size': this.get('adjustedFontSize'),
            fill: boxAttrs.textColor,
            'text-anchor':
                boxAttrs.textAlign === 'left'
                    ? 'start'
                    : '' //TODO: other valid values ... though not allowing to change currently -- 'start', 'middle', 'end' -- all values would require changes to the text placement inside the box
        };

    },


    getTextLineHeight: function() {
        return this.getBoxModel().get('lineHeight');
    },


    getConnectionLineColor: function() {
        return this.connectionModel.get('color');
    },

    getConnectionLineWidth: function()  {
        return this.get('adjustedConnectionWidth');
    },

    // Returns the array
    getConnectionDashArray: function() {
        return this.get('adjustedConnectionDashArray');
    },

    /* Note: connection width already taken into account at onset -- set on init */
    // TODO: better performance ... using rounding and _.map ???
    getConnectionDashArraySVGValue: function(scale ) {

        scale = scale || 1;
       
        var dashArray = this.getConnectionDashArray(); 
        
        // Don't perform any calc's if the value is null
        if (!dashArray)
            return null;

        return  _.map( dashArray, function(i) {
            return +( i * scale ).toFixed(3);
        } ).join(',');

    },

    /*
    * Connection attr's except:
    *   - color: passed in separately to the connect 'plugin'
    *   - dashArray: applied separately to avoid Raphael internal dashArray calculations (and to include scale value)
    *   - stroke-width: now set separately to include the scale value ( see shapeView )
    * */
    getConnectionLineAttrs: function() {

        var connectionAttrs = this.connectionModel.toJSON();

        var attrs = {
            'stroke-opacity': connectionAttrs.opacity
        };

        return attrs;

    },

    getStrokeWidth: function() {
        return this.get('adjustedStrokeWidth');
    },

    getPadding: function() {
        return this.get('adjustedPadding');
    },

    getBoxModel: function() {
        return this.boxModel;
    },
    getConnectionModel: function() {
        return this.connectionModel;
    },

    getPgDpi: function() {
        return this.get('pgDPI');
    }


});





/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/views/shape/redaction/floatingCodes/codeUiModel.js
 ** module id = 248
 ** module chunks = 0
 **/